// Generated by scripts/asset_sizes.py — do not edit. Every picture's width x height, by
// texture key: what it costs decoded (x4 bytes), known before it is downloaded.
export const PIXELS = {
  animal_kot: 65536,
  animal_krowa: 102400,
  animal_kura: 65536,
  animal_pies: 65536,
  backgammon_board: 1572864,
  backgammon_checker_b: 16384,
  backgammon_checker_w: 16384,
  backgammon_die_1: 16384,
  backgammon_die_2: 16384,
  backgammon_die_3: 16384,
  backgammon_die_4: 16384,
  backgammon_die_5: 16384,
  backgammon_die_6: 16384,
  bg_animal_yard_day: 1573352,
  bg_animal_yard_evening: 1573352,
  bg_animal_yard_morning: 1573352,
  bg_animal_yard_night: 1573352,
  bg_backyard_day_lvl1: 2360028,
  bg_backyard_day_lvl2: 2360028,
  bg_backyard_day_lvl3: 2360028,
  bg_backyard_day_lvl4: 2360028,
  bg_backyard_day_lvl5: 2360028,
  bg_backyard_evening_lvl1: 2360028,
  bg_backyard_evening_lvl2: 2360028,
  bg_backyard_evening_lvl3: 2360028,
  bg_backyard_evening_lvl4: 2360028,
  bg_backyard_evening_lvl5: 2360028,
  bg_backyard_morning_lvl1: 2360028,
  bg_backyard_morning_lvl2: 2360028,
  bg_backyard_morning_lvl3: 2360028,
  bg_backyard_morning_lvl4: 2360028,
  bg_backyard_morning_lvl5: 2360028,
  bg_backyard_night_lvl1: 2360028,
  bg_backyard_night_lvl2: 2360028,
  bg_backyard_night_lvl3: 2360028,
  bg_backyard_night_lvl4: 2360028,
  bg_backyard_night_lvl5: 2360028,
  bg_bike_shop: 1573352,
  bg_bike_shop_0: 2465420,
  bg_bike_shop_1: 2465420,
  bg_board_game: 921600,
  bg_car_dealer: 3146704,
  bg_car_dealer_left: 1573352,
  bg_car_dealer_right: 1573352,
  bg_clothing_shop: 1573352,
  bg_driving_school: 1573352,
  bg_furniture_shop: 1573352,
  bg_game_hall_down: 921600,
  bg_game_hall_up: 921600,
  bg_garden_lvl3_day: 1573352,
  bg_garden_lvl3_evening: 1573352,
  bg_garden_lvl3_morning: 1573352,
  bg_garden_lvl3_night: 1573352,
  bg_home: 1573352,
  bg_home_lvl2: 1573352,
  bg_home_lvl3: 1573352,
  bg_home_lvl4: 1573352,
  bg_home_lvl5: 1573352,
  bg_kitchen: 1573352,
  bg_main_day: 1573352,
  bg_main_day_lvl2: 1573352,
  bg_main_day_lvl3: 1573352,
  bg_main_day_lvl4: 1573352,
  bg_main_day_lvl5: 1573352,
  bg_main_evening: 1573352,
  bg_main_evening_lvl2: 1573352,
  bg_main_evening_lvl3: 1573352,
  bg_main_evening_lvl4: 1573352,
  bg_main_evening_lvl5: 1573352,
  bg_main_morning: 1573352,
  bg_main_morning_lvl2: 1573352,
  bg_main_morning_lvl3: 1573352,
  bg_main_morning_lvl4: 1573352,
  bg_main_morning_lvl5: 1573352,
  bg_main_night: 1573352,
  bg_main_night_lvl2: 1573352,
  bg_main_night_lvl3: 1573352,
  bg_main_night_lvl4: 1573352,
  bg_main_night_lvl5: 1573352,
  bg_pet_shop: 1573352,
  bg_salon: 1573352,
  bg_second_floor: 1573352,
  bg_seg_country: 3144822,
  bg_seg_crossing: 3144822,
  bg_seg_lights: 3144822,
  bg_seg_limit50: 3144822,
  bg_seg_noentry: 3144822,
  bg_seg_parking: 3144822,
  bg_seg_school: 3144822,
  bg_seg_solid: 3144822,
  bg_seg_stop: 3144822,
  bg_seg_yield: 3144822,
  bg_shop: 1573352,
  bg_street_0: 1967631,
  bg_street_1: 1967631,
  bg_street_2: 1967631,
  bg_street_3: 1967631,
  bg_street_day_0: 1695801,
  bg_street_day_1: 1695801,
  bg_street_day_2: 1695801,
  bg_street_day_3: 1695801,
  bg_street_evening_0: 1695801,
  bg_street_evening_1: 1695801,
  bg_street_evening_2: 1695801,
  bg_street_evening_3: 1695801,
  bg_street_morning_0: 1695801,
  bg_street_morning_1: 1695801,
  bg_street_morning_2: 1695801,
  bg_street_morning_3: 1695801,
  bg_street_night_0: 1695801,
  bg_street_night_1: 1695801,
  bg_street_night_2: 1695801,
  bg_street_night_3: 1695801,
  bg_yard_back_day_lvl1: 2360028,
  bg_yard_back_day_lvl2: 2360028,
  bg_yard_back_day_lvl3: 2360028,
  bg_yard_back_day_lvl4: 2360028,
  bg_yard_back_day_lvl5: 2360028,
  bg_yard_back_evening_lvl1: 2360028,
  bg_yard_back_evening_lvl2: 2360028,
  bg_yard_back_evening_lvl3: 2360028,
  bg_yard_back_evening_lvl4: 2360028,
  bg_yard_back_evening_lvl5: 2360028,
  bg_yard_back_far_day: 501600,
  bg_yard_back_far_evening: 501600,
  bg_yard_back_far_morning: 501600,
  bg_yard_back_far_night: 501600,
  bg_yard_back_morning_lvl1: 2360028,
  bg_yard_back_morning_lvl2: 2360028,
  bg_yard_back_morning_lvl3: 2360028,
  bg_yard_back_morning_lvl4: 2360028,
  bg_yard_back_morning_lvl5: 2360028,
  bg_yard_back_night_lvl1: 2360028,
  bg_yard_back_night_lvl2: 2360028,
  bg_yard_back_night_lvl3: 2360028,
  bg_yard_back_night_lvl4: 2360028,
  bg_yard_back_night_lvl5: 2360028,
  bg_yard_front_day_lvl1: 1573352,
  bg_yard_front_day_lvl2: 1573352,
  bg_yard_front_day_lvl3: 1573352,
  bg_yard_front_day_lvl4: 1573352,
  bg_yard_front_day_lvl5: 1573352,
  bg_yard_front_evening_lvl1: 1573352,
  bg_yard_front_evening_lvl2: 1573352,
  bg_yard_front_evening_lvl3: 1573352,
  bg_yard_front_evening_lvl4: 1573352,
  bg_yard_front_evening_lvl5: 1573352,
  bg_yard_front_morning_lvl1: 1573352,
  bg_yard_front_morning_lvl2: 1573352,
  bg_yard_front_morning_lvl3: 1573352,
  bg_yard_front_morning_lvl4: 1573352,
  bg_yard_front_morning_lvl5: 1573352,
  bg_yard_front_night_lvl1: 1573352,
  bg_yard_front_night_lvl2: 1573352,
  bg_yard_front_night_lvl3: 1573352,
  bg_yard_front_night_lvl4: 1573352,
  bg_yard_front_night_lvl5: 1573352,
  bike_blue: 230400,
  bike_blue_grafitowy: 572270,
  bike_blue_niebieski: 977855,
  bike_blue_ocean: 574695,
  bike_blue_plomienie: 568071,
  bike_blue_wisniowy: 583416,
  bike_blue_wyscigowy: 567432,
  bike_cloth_ken_ken_akc_beanie: 59701,
  bike_cloth_ken_ken_akc_cap: 68912,
  bike_cloth_ken_ken_akc_headphones: 18327,
  bike_cloth_ken_ken_akc_sunglasses: 14444,
  bike_cloth_ken_ken_akc_sunglasses_mask: 2512,
  bike_cloth_ken_ken_cargo: 1557215,
  bike_cloth_ken_ken_cargo_mask: 259741,
  bike_cloth_ken_ken_hoodie: 133926,
  bike_cloth_ken_ken_jacket_plaid: 150900,
  bike_cloth_ken_ken_jacket_plaid_mask: 25150,
  bike_cloth_ken_ken_jeans_black: 1660076,
  bike_cloth_ken_ken_jeans_black_mask: 276892,
  bike_cloth_ken_ken_joggers: 1392256,
  bike_cloth_ken_ken_joggers_mask: 232432,
  bike_cloth_ken_ken_shoes_boots: 963186,
  bike_cloth_ken_ken_shoes_boots_mask: 160854,
  bike_cloth_ken_ken_shoes_japonki: 872160,
  bike_cloth_ken_ken_shoes_japonki_mask: 145992,
  bike_cloth_ken_ken_shoes_runner: 867783,
  bike_cloth_ken_ken_shoes_runner_mask: 145111,
  bike_cloth_ken_ken_shoes_white: 816130,
  bike_cloth_ken_ken_shoes_white_mask: 136633,
  bike_cloth_ken_ken_shorts_denim: 664189,
  bike_cloth_ken_ken_shorts_denim_mask: 110833,
  bike_cloth_ken_ken_tee_brown: 96747,
  bike_cloth_ken_ken_tee_brown_mask: 16422,
  bike_cloth_ken_ken_tee_logo: 62496,
  bike_cloth_ken_ken_tee_logo_mask: 10656,
  bike_cloth_natalka_akc_kapelusz: 103296,
  bike_cloth_natalka_akc_kapelusz_mask: 17280,
  bike_cloth_natalka_akc_kokarda: 30780,
  bike_cloth_natalka_akc_korona: 45584,
  bike_cloth_natalka_akc_okulary: 9605,
  bike_cloth_natalka_bluzka_blue: 59488,
  bike_cloth_natalka_bluzka_green: 62766,
  bike_cloth_natalka_bluzka_red: 81666,
  bike_cloth_natalka_bluzka_red_mask: 13611,
  bike_cloth_natalka_bluzka_stripes: 62856,
  bike_cloth_natalka_buty_balet: 853740,
  bike_cloth_natalka_buty_balet_mask: 142290,
  bike_cloth_natalka_buty_kozaki: 878724,
  bike_cloth_natalka_buty_kozaki_mask: 146916,
  bike_cloth_natalka_buty_sandaly: 832600,
  bike_cloth_natalka_buty_sandaly_mask: 139370,
  bike_cloth_natalka_buty_sport: 839666,
  bike_cloth_natalka_buty_sport_mask: 140100,
  bike_cloth_natalka_nat_basket_shoes: 892080,
  bike_cloth_natalka_nat_basket_shoes_mask: 149152,
  bike_cloth_natalka_nat_bucket_hat: 91866,
  bike_cloth_natalka_nat_corduroy: 1751380,
  bike_cloth_natalka_nat_flares_lavender: 1714790,
  bike_cloth_natalka_nat_fleece_brown: 111935,
  bike_cloth_natalka_nat_headband: 69156,
  bike_cloth_natalka_nat_headphones: 27939,
  bike_cloth_natalka_nat_jacket_denim: 131412,
  bike_cloth_natalka_nat_jeans_wide: 1691280,
  bike_cloth_natalka_nat_jersey_basket: 83760,
  bike_cloth_natalka_nat_jersey_basket_mask: 13960,
  bike_cloth_natalka_nat_joggers_light: 1293486,
  bike_cloth_natalka_nat_parachute: 1537564,
  bike_cloth_natalka_nat_parachute_mask: 256672,
  bike_cloth_natalka_nat_patchwork: 1688194,
  bike_cloth_natalka_nat_slipons_check: 751608,
  bike_cloth_natalka_nat_slipons_check_mask: 125268,
  bike_cloth_natalka_nat_sweater_band: 109470,
  bike_cloth_natalka_nat_sweater_band_mask: 18450,
  bike_cloth_natalka_nat_tee_blue_word: 63242,
  bike_cloth_natalka_nat_tee_wave: 71100,
  bike_cloth_natalka_nat_vest_puffer: 65940,
  bike_cloth_natalka_nat_wellies: 1040550,
  bike_cloth_natalka_nat_wellies_mask: 174300,
  bike_cloth_natalka_spodniczka_black: 641376,
  bike_cloth_natalka_spodniczka_black_mask: 106896,
  bike_cloth_natalka_spodniczka_flowers: 944588,
  bike_cloth_natalka_spodniczka_flowers_mask: 158070,
  bike_cloth_natalka_spodniczka_jeans: 1489590,
  bike_cloth_natalka_spodniczka_pink: 726484,
  bike_cloth_natalka_spodniczka_pink_mask: 121220,
  bike_grease: 230400,
  bike_hair_ken_ken_buzz: 55704,
  bike_hair_ken_ken_buzz_mask: 9504,
  bike_hair_ken_ken_curls: 108810,
  bike_hair_ken_ken_curls_mask: 18252,
  bike_hair_ken_ken_fringe: 71764,
  bike_hair_ken_ken_fringe_hat: 69834,
  bike_hair_ken_ken_fringe_hat_mask: 11742,
  bike_hair_ken_ken_fringe_mask: 12012,
  bike_hair_ken_ken_short_crop: 68850,
  bike_hair_ken_ken_short_crop_hat: 65712,
  bike_hair_ken_ken_short_crop_hat_mask: 10952,
  bike_hair_ken_ken_short_crop_mask: 11628,
  bike_hair_ken_ken_spiky: 77197,
  bike_hair_ken_ken_spiky_hat: 70840,
  bike_hair_ken_ken_spiky_hat_mask: 12012,
  bike_hair_ken_ken_spiky_mask: 12920,
  bike_hair_natalka_nat_half_up: 189776,
  bike_hair_natalka_nat_half_up_hat: 167640,
  bike_hair_natalka_nat_half_up_hat_mask: 28160,
  bike_hair_natalka_nat_half_up_mask: 32016,
  bike_hair_natalka_nat_long_sleek: 137295,
  bike_hair_natalka_nat_long_sleek_hat: 135788,
  bike_hair_natalka_nat_long_sleek_hat_mask: 22904,
  bike_hair_natalka_nat_long_sleek_mask: 23085,
  bike_hair_natalka_nat_pigtails: 171954,
  bike_hair_natalka_nat_pigtails_mask: 28892,
  bike_hair_natalka_nat_ponytail: 140818,
  bike_hair_natalka_nat_ponytail_hat: 173910,
  bike_hair_natalka_nat_ponytail_hat_mask: 29295,
  bike_hair_natalka_nat_ponytail_mask: 23729,
  bike_hair_natalka_nat_ringlets: 113880,
  bike_hair_natalka_nat_ringlets_hat: 86240,
  bike_hair_natalka_nat_ringlets_hat_mask: 14432,
  bike_hair_natalka_nat_ringlets_mask: 19110,
  bike_hair_natalka_nat_rounded_bob: 153374,
  bike_hair_natalka_nat_rounded_bob_hat: 69520,
  bike_hair_natalka_nat_rounded_bob_hat_mask: 11692,
  bike_hair_natalka_nat_rounded_bob_mask: 25636,
  bike_hair_natalka_nat_wavy_lob: 93272,
  bike_hair_natalka_nat_wavy_lob_hat: 86697,
  bike_hair_natalka_nat_wavy_lob_hat_mask: 14742,
  bike_hair_natalka_nat_wavy_lob_mask: 15664,
  bike_pink: 230400,
  bike_pink_arbuz: 524446,
  bike_pink_biedronka: 525922,
  bike_pink_cytrynowy: 531566,
  bike_pink_jednorozec: 526838,
  bike_pink_mietowy: 519468,
  bike_pink_rozowy: 788925,
  bike_rider_ken: 2109726,
  bike_rider_ken_mask: 351621,
  bike_rider_natalka: 2061996,
  bike_rider_natalka_mask: 344148,
  buda_buda: 57600,
  buda_kocie: 57600,
  buda_kurnik: 57600,
  buda_obora: 57600,
  car_bclass_front: 240000,
  car_bclass_side: 135000,
  car_c8_front: 266800,
  car_c8_side: 150300,
  car_model3_front: 240000,
  car_model3_side: 135000,
  car_panda_front: 240000,
  car_panda_side: 135000,
  car_q5_front: 240000,
  car_q5_side: 135000,
  car_t03_front: 240000,
  car_t03_side: 135000,
  car_yaris_l_front: 266800,
  car_yaris_l_side: 150300,
  checkers_board: 1048576,
  checkers_piece_brown: 64000,
  checkers_piece_red: 64256,
  checkers_queen_brown: 64256,
  checkers_queen_red: 64512,
  cloth_akc_kapelusz: 262144,
  cloth_akc_kokarda: 262144,
  cloth_akc_kokarda_back: 262144,
  cloth_akc_korona: 262144,
  cloth_akc_korona_back: 262144,
  cloth_akc_okulary: 262144,
  cloth_bluzka_blue: 262144,
  cloth_bluzka_green: 262144,
  cloth_bluzka_red: 262144,
  cloth_bluzka_stripes: 262144,
  cloth_buty_balet: 262144,
  cloth_buty_kozaki: 262144,
  cloth_buty_sandaly: 262144,
  cloth_buty_sport: 262144,
  cloth_ken_akc_beanie: 262144,
  cloth_ken_akc_cap: 262144,
  cloth_ken_akc_headphones: 262144,
  cloth_ken_akc_sunglasses: 262144,
  cloth_ken_cargo: 262144,
  cloth_ken_hoodie: 262144,
  cloth_ken_jacket_plaid: 262144,
  cloth_ken_jeans_black: 262144,
  cloth_ken_joggers: 262144,
  cloth_ken_shoes_boots: 262144,
  cloth_ken_shoes_japonki: 262144,
  cloth_ken_shoes_runner: 262144,
  cloth_ken_shoes_white: 262144,
  cloth_ken_shorts_denim: 262144,
  cloth_ken_tee_brown: 262144,
  cloth_ken_tee_logo: 262144,
  cloth_nat_basket_shoes: 65536,
  cloth_nat_bucket_hat: 65536,
  cloth_nat_corduroy: 65536,
  cloth_nat_flares_lavender: 65536,
  cloth_nat_fleece_brown: 65536,
  cloth_nat_headband: 65536,
  cloth_nat_headphones: 65536,
  cloth_nat_jacket_denim: 65536,
  cloth_nat_jeans_wide: 65536,
  cloth_nat_jersey_basket: 65536,
  cloth_nat_joggers_light: 65536,
  cloth_nat_parachute: 65536,
  cloth_nat_patchwork: 65536,
  cloth_nat_slipons_check: 65536,
  cloth_nat_sweater_band: 65536,
  cloth_nat_sweater_knit: 65536,
  cloth_nat_tee_blue_word: 65536,
  cloth_nat_tee_wave: 65536,
  cloth_nat_vest_puffer: 65536,
  cloth_nat_wellies: 65536,
  cloth_spodniczka_black: 262144,
  cloth_spodniczka_flowers: 262144,
  cloth_spodniczka_jeans: 262144,
  cloth_spodniczka_pink: 262144,
  decoration_balony: 141220,
  decoration_dywan: 396900,
  decoration_fontanna: 624100,
  decoration_girlanda: 235200,
  decoration_latarnia: 369800,
  decoration_lawka: 152100,
  decoration_plakat: 102400,
  decoration_posag: 115600,
  decoration_roslina: 57600,
  decoration_skrzynka_kwiaty: 115600,
  decoration_zyrandol: 211600,
  driver_ken: 76800,
  driver_ken_ken_buzz: 76800,
  driver_ken_ken_buzz_mask: 12800,
  driver_ken_ken_fringe: 76800,
  driver_ken_ken_fringe_mask: 12800,
  driver_ken_ken_short_crop: 76800,
  driver_ken_ken_short_crop_mask: 12800,
  driver_ken_ken_spiky: 76800,
  driver_ken_ken_spiky_mask: 12800,
  driver_ken_mask: 12800,
  driver_natalka: 52800,
  driver_natalka_mask: 8960,
  driver_natalka_nat_half_up: 52800,
  driver_natalka_nat_half_up_mask: 8960,
  driver_natalka_nat_long_sleek: 52800,
  driver_natalka_nat_long_sleek_mask: 8960,
  driver_natalka_nat_ponytail: 52800,
  driver_natalka_nat_ponytail_mask: 8960,
  driver_natalka_nat_ponytail_r: 52800,
  driver_natalka_nat_ponytail_r_mask: 8960,
  driver_natalka_nat_ringlets: 52800,
  driver_natalka_nat_ringlets_mask: 8960,
  driver_natalka_nat_rounded_bob: 52800,
  driver_natalka_nat_rounded_bob_mask: 8960,
  driver_natalka_nat_rounded_bob_r: 52800,
  driver_natalka_nat_rounded_bob_r_mask: 8960,
  driver_natalka_nat_wavy_lob: 52800,
  driver_natalka_nat_wavy_lob_mask: 8960,
  egg_1: 6400,
  egg_2: 6400,
  eggs_2: 12544,
  eggs_3: 12544,
  eggs_4: 12544,
  eggs_5: 12544,
  facade_meble: 1048576,
  facade_sklep_rowerowy: 1572516,
  facade_ubrania: 1572516,
  facade_warzywniak: 1833316,
  facade_zwierzeta: 1048576,
  farm_animal_krowa_idle: 62426,
  farm_animal_krowa_stand: 67872,
  farm_animal_krowa_walk0: 70902,
  farm_animal_krowa_walk1: 72922,
  farm_animal_krowa_walk2: 72674,
  farm_animal_krowa_walk3: 71355,
  farm_animal_kura_idle: 32926,
  farm_animal_kura_stand: 36084,
  farm_animal_kura_walk0: 37200,
  farm_animal_kura_walk1: 36600,
  farm_animal_kura_walk2: 37400,
  farm_animal_kura_walk3: 37600,
  farm_bd_barn: 14964,
  farm_bd_bird_0: 4992,
  farm_bd_bird_1: 4992,
  farm_bd_blades: 10712,
  farm_bd_cloud_0: 36120,
  farm_bd_cloud_1: 29820,
  farm_bd_cloud_2: 28140,
  farm_bd_cloud_3: 43840,
  farm_bd_cloud_4: 37940,
  farm_bd_far: 372680,
  farm_bd_farmhouse: 14964,
  farm_bd_mid: 189760,
  farm_bd_moon: 12432,
  farm_bd_near: 95400,
  farm_bd_silo: 5304,
  farm_bd_sun: 36288,
  farm_bd_tree_0: 13888,
  farm_bd_tree_1: 9216,
  farm_bd_tree_2: 14000,
  farm_bd_tree_3: 11232,
  farm_bd_tuft_0: 3264,
  farm_bd_tuft_1: 3072,
  farm_bd_tuft_2: 3024,
  farm_bd_tuft_3: 3120,
  farm_bd_windmill: 10480,
  farm_car_bclass: 108307,
  farm_car_c8: 93069,
  farm_car_model3: 95380,
  farm_car_panda: 82503,
  farm_car_q5: 118400,
  farm_car_t03: 87636,
  farm_car_yaris_l: 94185,
  farm_crop_arbuz_growing: 22932,
  farm_crop_arbuz_ready: 28560,
  farm_crop_arbuz_seedling: 16320,
  farm_crop_bratek_czerwonopomaranczowy_growing: 21204,
  farm_crop_bratek_czerwonopomaranczowy_ready: 26384,
  farm_crop_bratek_czerwonopomaranczowy_seedling: 16856,
  farm_crop_bratek_growing: 21204,
  farm_crop_bratek_niebieski_growing: 21204,
  farm_crop_bratek_niebieski_ready: 26384,
  farm_crop_bratek_niebieski_seedling: 16856,
  farm_crop_bratek_ready: 26384,
  farm_crop_bratek_seedling: 16856,
  farm_crop_bratek_zolty_growing: 21204,
  farm_crop_bratek_zolty_ready: 26384,
  farm_crop_bratek_zolty_seedling: 16856,
  farm_crop_cukinia_growing: 22632,
  farm_crop_cukinia_ready: 28496,
  farm_crop_cukinia_seedling: 14938,
  farm_crop_dynia_growing: 22568,
  farm_crop_dynia_ready: 29988,
  farm_crop_dynia_seedling: 16016,
  farm_crop_kukurydza_growing: 27300,
  farm_crop_kukurydza_ready: 32926,
  farm_crop_kukurydza_seedling: 16830,
  farm_crop_lawenda_growing: 23940,
  farm_crop_lawenda_ready: 30906,
  farm_crop_lawenda_seedling: 17472,
  farm_crop_mak_growing: 25270,
  farm_crop_mak_ready: 32118,
  farm_crop_mak_seedling: 16632,
  farm_crop_malina_growing: 28574,
  farm_crop_malina_ready: 33990,
  farm_crop_malina_seedling: 17696,
  farm_crop_marchewka_growing: 26598,
  farm_crop_marchewka_ready: 32342,
  farm_crop_marchewka_seedling: 17400,
  farm_crop_ogorek_growing: 29666,
  farm_crop_ogorek_ready: 35476,
  farm_crop_ogorek_seedling: 18408,
  farm_crop_papryka_growing: 24640,
  farm_crop_papryka_ready: 30488,
  farm_crop_papryka_seedling: 18080,
  farm_crop_pomidor_growing: 26560,
  farm_crop_pomidor_ready: 33840,
  farm_crop_pomidor_seedling: 18328,
  farm_crop_pszenica_growing: 24130,
  farm_crop_pszenica_ready: 28078,
  farm_crop_pszenica_seedling: 18190,
  farm_crop_roza_bialy_growing: 28336,
  farm_crop_roza_bialy_ready: 31518,
  farm_crop_roza_bialy_seedling: 16748,
  farm_crop_roza_czarny_growing: 28520,
  farm_crop_roza_czarny_ready: 31724,
  farm_crop_roza_czarny_seedling: 16906,
  farm_crop_roza_growing: 28704,
  farm_crop_roza_ready: 31930,
  farm_crop_roza_seedling: 17064,
  farm_crop_roza_zolty_growing: 28520,
  farm_crop_roza_zolty_ready: 31724,
  farm_crop_roza_zolty_seedling: 16906,
  farm_crop_rzodkiewka_growing: 23920,
  farm_crop_rzodkiewka_ready: 31106,
  farm_crop_rzodkiewka_seedling: 16224,
  farm_crop_salata_growing: 23852,
  farm_crop_salata_ready: 30192,
  farm_crop_salata_seedling: 16478,
  farm_crop_slonecznik_growing: 29848,
  farm_crop_slonecznik_ready: 33642,
  farm_crop_slonecznik_seedling: 17864,
  farm_crop_stokrotka_growing: 22610,
  farm_crop_stokrotka_ready: 28886,
  farm_crop_stokrotka_seedling: 16182,
  farm_crop_storczyk_fioletowy_growing: 28086,
  farm_crop_storczyk_fioletowy_ready: 36050,
  farm_crop_storczyk_fioletowy_seedling: 18848,
  farm_crop_storczyk_growing: 28086,
  farm_crop_storczyk_niebieski_growing: 27714,
  farm_crop_storczyk_niebieski_ready: 36256,
  farm_crop_storczyk_niebieski_seedling: 18544,
  farm_crop_storczyk_ready: 36256,
  farm_crop_storczyk_seedling: 19000,
  farm_crop_storczyk_zolty_growing: 27714,
  farm_crop_storczyk_zolty_ready: 35844,
  farm_crop_storczyk_zolty_seedling: 18848,
  farm_crop_truskawka_growing: 23994,
  farm_crop_truskawka_ready: 31512,
  farm_crop_truskawka_seedling: 17334,
  farm_crop_tulipan_fioletowy_growing: 25200,
  farm_crop_tulipan_fioletowy_ready: 35340,
  farm_crop_tulipan_fioletowy_seedling: 15912,
  farm_crop_tulipan_growing: 25200,
  farm_crop_tulipan_ready: 35340,
  farm_crop_tulipan_rozowy_growing: 25020,
  farm_crop_tulipan_rozowy_ready: 35340,
  farm_crop_tulipan_rozowy_seedling: 15912,
  farm_crop_tulipan_seedling: 15912,
  farm_crop_tulipan_zolty_growing: 25020,
  farm_crop_tulipan_zolty_ready: 35340,
  farm_crop_tulipan_zolty_seedling: 15912,
  farm_crop_ziemniak_growing: 23940,
  farm_crop_ziemniak_ready: 33904,
  farm_crop_ziemniak_seedling: 18306,
  farm_crop_zyto_growing: 28012,
  farm_crop_zyto_ready: 30600,
  farm_crop_zyto_seedling: 17680,
  farm_fence_post: 3596,
  farm_fence_se: 12288,
  farm_fence_sw: 12288,
  farm_fx_splash: 19520,
  farm_gate: 12288,
  farm_house_lvl1: 745920,
  farm_house_lvl2: 745920,
  farm_house_lvl3: 745920,
  farm_house_lvl4: 745920,
  farm_house_lvl5: 745920,
  farm_lawn: 18432,
  farm_obj_balony: 15730,
  farm_obj_fence_post: 1166,
  farm_obj_fence_rail: 1768,
  farm_obj_fontanna: 35600,
  farm_obj_girlanda: 8580,
  farm_obj_kurnik: 26553,
  farm_obj_latarnia: 9350,
  farm_obj_lawka: 28600,
  farm_obj_mlyn: 66000,
  farm_obj_obora: 31845,
  farm_obj_plaque: 11880,
  farm_obj_posag: 13940,
  farm_obj_roslina: 11880,
  farm_obj_siano: 11660,
  farm_obj_skrzynka_kwiaty: 10230,
  farm_obj_stodola: 33000,
  farm_obj_szklarnia: 65400,
  farm_obj_wiatrak: 45600,
  farm_obj_willa: 102400,
  farm_podworko_lvl1: 1261568,
  farm_podworko_lvl2: 1261568,
  farm_podworko_lvl3: 1261568,
  farm_podworko_lvl4: 1261568,
  farm_podworko_lvl5: 1261568,
  farm_prop_brzoza: 55200,
  farm_prop_brzoza_young: 14600,
  farm_prop_bush: 19760,
  farm_prop_chabry: 6320,
  farm_prop_dab: 87600,
  farm_prop_dzika_roza: 12870,
  farm_prop_flowers_pink: 9090,
  farm_prop_flowers_yellow: 8910,
  farm_prop_jalowiec: 13530,
  farm_prop_kamien_mech: 10170,
  farm_prop_kloda: 9240,
  farm_prop_leszczyna: 22440,
  farm_prop_lipa: 69000,
  farm_prop_maki: 5840,
  farm_prop_mlecze: 6232,
  farm_prop_muchomory: 3660,
  farm_prop_paproc: 10350,
  farm_prop_pniak: 6790,
  farm_prop_rock: 6440,
  farm_prop_rumianek: 6880,
  farm_prop_sosna: 64600,
  farm_prop_swierk: 61200,
  farm_prop_swierk_young: 14080,
  farm_prop_tree: 58960,
  farm_prop_trzcina: 11640,
  farm_prop_tuft: 8370,
  farm_tile_fallow: 18432,
  farm_tile_grass: 18432,
  farm_tile_path: 18432,
  farm_tile_plowed: 18432,
  farm_tool_konewka: 53040,
  farm_tree_brzoskwinia_grown: 41100,
  farm_tree_brzoskwinia_ripe: 41100,
  farm_tree_brzoskwinia_sapling: 12960,
  farm_tree_grusza_grown: 40800,
  farm_tree_grusza_ripe: 40950,
  farm_tree_grusza_sapling: 11700,
  farm_tree_jablon_grown: 39600,
  farm_tree_jablon_ripe: 39600,
  farm_tree_jablon_sapling: 12240,
  farm_tree_orzech_grown: 114840,
  farm_tree_orzech_ripe: 115920,
  farm_tree_orzech_sapling: 59904,
  farm_tree_sliwa_grown: 40650,
  farm_tree_sliwa_ripe: 40650,
  farm_tree_sliwa_sapling: 9540,
  farm_tree_wisnia_grown: 34200,
  farm_tree_wisnia_ripe: 34200,
  farm_tree_wisnia_sapling: 9000,
  farm_vehicle_harvester_2: 32487,
  farm_vehicle_harvester_4: 87600,
  farm_vehicle_seeder_2: 28951,
  farm_vehicle_seeder_4: 79205,
  farm_vehicle_tractor_2: 30719,
  farm_vehicle_tractor_4: 82125,
  food_mieso: 25600,
  food_siano: 25600,
  food_ziarno: 25600,
  furniture_kanapa: 277920,
  furniture_kanapa_2: 285120,
  furniture_kanapa_3: 290160,
  furniture_kanapa_4: 280080,
  furniture_kanapa_5: 262080,
  furniture_kanapa_6: 282960,
  furniture_kanapa_7: 276480,
  furniture_lampa: 230400,
  furniture_lozko: 315600,
  furniture_lozko_2: 325800,
  furniture_lozko_2_front: 325800,
  furniture_lozko_3: 352200,
  furniture_lozko_3_front: 352200,
  furniture_lozko_4: 315600,
  furniture_lozko_4_front: 315600,
  furniture_lozko_5: 322200,
  furniture_lozko_5_front: 322200,
  furniture_lozko_6: 354600,
  furniture_lozko_6_front: 354600,
  furniture_lozko_7: 337800,
  furniture_lozko_7_front: 337800,
  furniture_lozko_front: 315600,
  furniture_obraz: 57600,
  furniture_szafa: 230400,
  furniture_zegar: 10000,
  furniture_zegar_hand: 16384,
  game_backgammon: 168960,
  game_checkers: 153120,
  game_chess: 172800,
  game_go: 154560,
  game_makao: 157920,
  game_mancala: 157920,
  icon_back: 36864,
  icon_home: 36864,
  icon_hungry: 36864,
  icon_lock: 36864,
  icon_outside: 36864,
  icon_pet_heart: 36864,
  icon_shop: 36864,
  junction_country__limit50: 1572411,
  junction_country__parking: 1572411,
  junction_country__yield: 1572411,
  junction_crossing__lights: 1572411,
  junction_lights__school: 1572411,
  junction_lights__solid: 1572411,
  junction_limit50__crossing: 1572411,
  junction_limit50__stop: 1572411,
  junction_school__noentry: 1572411,
  junction_school__parking: 1572411,
  junction_solid__country: 1572411,
  junction_stop__country: 1572411,
  junction_stop__crossing: 1572411,
  junction_yield__country: 1572411,
  junction_yield__school: 1572411,
  ken_base: 196608,
  ken_walk: 7372800,
  ken_walk_ken_akc_beanie: 7372800,
  ken_walk_ken_akc_cap: 7372800,
  ken_walk_ken_akc_headphones: 7372800,
  ken_walk_ken_akc_sunglasses: 7372800,
  ken_walk_ken_cargo: 7372800,
  ken_walk_ken_hoodie: 7372800,
  ken_walk_ken_jacket_plaid: 7372800,
  ken_walk_ken_jeans_black: 7372800,
  ken_walk_ken_joggers: 7372800,
  ken_walk_ken_shoes_boots: 7372800,
  ken_walk_ken_shoes_japonki: 7372800,
  ken_walk_ken_shoes_runner: 7372800,
  ken_walk_ken_shoes_white: 7372800,
  ken_walk_ken_shorts_denim: 7372800,
  ken_walk_ken_tee_brown: 7372800,
  ken_walk_ken_tee_logo: 7372800,
  mancala_board: 1056162,
  mancala_stone_0: 16384,
  mancala_stone_1: 16384,
  mancala_stone_2: 16384,
  mancala_stone_3: 16384,
  milk_2: 12544,
  milk_3: 12544,
  milk_4: 12544,
  milk_5: 12544,
  natalka: 262144,
  natalka_base: 262144,
  natalka_walk: 7372800,
  natalka_walk_akc_kapelusz: 7372800,
  natalka_walk_akc_kokarda: 7372800,
  natalka_walk_akc_korona: 7372800,
  natalka_walk_akc_okulary: 7372800,
  natalka_walk_bluzka_blue: 7372800,
  natalka_walk_bluzka_green: 7372800,
  natalka_walk_bluzka_red: 7372800,
  natalka_walk_bluzka_stripes: 7372800,
  natalka_walk_buty_balet: 7372800,
  natalka_walk_buty_kozaki: 7372800,
  natalka_walk_buty_sandaly: 7372800,
  natalka_walk_buty_sport: 7372800,
  natalka_walk_nat_basket_shoes: 7372800,
  natalka_walk_nat_bucket_hat: 7372800,
  natalka_walk_nat_corduroy: 7372800,
  natalka_walk_nat_flares_lavender: 7372800,
  natalka_walk_nat_fleece_brown: 7372800,
  natalka_walk_nat_headband: 7372800,
  natalka_walk_nat_headphones: 7372800,
  natalka_walk_nat_jacket_denim: 7372800,
  natalka_walk_nat_jeans_wide: 7372800,
  natalka_walk_nat_jersey_basket: 7372800,
  natalka_walk_nat_joggers_light: 7372800,
  natalka_walk_nat_parachute: 7372800,
  natalka_walk_nat_patchwork: 7372800,
  natalka_walk_nat_slipons_check: 7372800,
  natalka_walk_nat_sweater_band: 7372800,
  natalka_walk_nat_sweater_knit: 7372800,
  natalka_walk_nat_tee_blue_word: 7372800,
  natalka_walk_nat_tee_wave: 7372800,
  natalka_walk_nat_vest_puffer: 7372800,
  natalka_walk_nat_wellies: 7372800,
  natalka_walk_spodniczka_black: 7372800,
  natalka_walk_spodniczka_flowers: 7372800,
  natalka_walk_spodniczka_jeans: 7372800,
  natalka_walk_spodniczka_pink: 7372800,
  npc_child: 153600,
  npc_child_side: 233760,
  npc_child_walk: 153600,
  npc_child_walk_right: 153600,
  npc_instructor: 153600,
  npc_mechanic: 153600,
  plot_empty: 57600,
  product_jajko: 6400,
  product_mleko: 6400,
  quiz_q02: 409600,
  quiz_q03: 409600,
  quiz_q05: 729600,
  quiz_q07: 546560,
  quiz_q10: 536320,
  quiz_q12: 409600,
  quiz_q13: 657280,
  quiz_q17: 726400,
  quiz_q18: 273280,
  quiz_q19: 273280,
  quiz_q21: 409600,
  quiz_q22: 618880,
  quiz_q25: 615040,
  quiz_q26: 409600,
  quiz_q27: 614400,
  quiz_q33: 728320,
  quiz_q34: 615040,
  quiz_q35: 585600,
  quiz_q36: 614400,
  quiz_q37: 811000,
  ranking_board: 376560,
  sign_crossing: 117600,
  sign_stop: 117600,
  sign_yield: 117600,
  traffic_light_green: 68480,
  traffic_light_red: 68480,
  traffic_light_redyellow: 68480,
};

// The packed walk and pose atlases and their masks (anim/packed/, no scene's tier), by texture key.
export const PACKED_PIXELS = {
  ken_pose: 294912,
  ken_pose_hair_ken_buzz: 81920,
  ken_pose_hair_ken_buzz_mask: 13680,
  ken_pose_hair_ken_curls: 114688,
  ken_pose_hair_ken_curls_mask: 19152,
  ken_pose_hair_ken_fringe: 98304,
  ken_pose_hair_ken_fringe_mask: 16416,
  ken_pose_hair_ken_short_crop: 98304,
  ken_pose_hair_ken_short_crop_mask: 16416,
  ken_pose_hair_ken_spiky: 98304,
  ken_pose_hair_ken_spiky_mask: 16416,
  ken_pose_hairback_ken_buzz: 1,
  ken_pose_hairback_ken_buzz_mask: 1,
  ken_pose_hairback_ken_curls: 1,
  ken_pose_hairback_ken_curls_mask: 1,
  ken_pose_hairback_ken_fringe: 1,
  ken_pose_hairback_ken_fringe_mask: 1,
  ken_pose_hairback_ken_short_crop: 1,
  ken_pose_hairback_ken_short_crop_mask: 1,
  ken_pose_hairback_ken_spiky: 1,
  ken_pose_hairback_ken_spiky_mask: 1,
  ken_pose_ken_akc_beanie: 98304,
  ken_pose_ken_akc_beanie_mask: 16416,
  ken_pose_ken_akc_cap: 65536,
  ken_pose_ken_akc_headphones: 65536,
  ken_pose_ken_akc_sunglasses: 65536,
  ken_pose_ken_akc_sunglasses_mask: 10944,
  ken_pose_ken_cargo: 114688,
  ken_pose_ken_cargo_mask: 19152,
  ken_pose_ken_hoodie: 114688,
  ken_pose_ken_hoodie_mask: 19152,
  ken_pose_ken_jacket_plaid: 147456,
  ken_pose_ken_jacket_plaid_mask: 24624,
  ken_pose_ken_jeans_black: 131072,
  ken_pose_ken_jeans_black_mask: 21888,
  ken_pose_ken_joggers: 98304,
  ken_pose_ken_joggers_mask: 16416,
  ken_pose_ken_shoes_boots: 81920,
  ken_pose_ken_shoes_boots_mask: 13680,
  ken_pose_ken_shoes_japonki: 65536,
  ken_pose_ken_shoes_japonki_mask: 10944,
  ken_pose_ken_shoes_runner: 65536,
  ken_pose_ken_shoes_runner_mask: 10944,
  ken_pose_ken_shoes_white: 65536,
  ken_pose_ken_shoes_white_mask: 10944,
  ken_pose_ken_shorts_denim: 163840,
  ken_pose_ken_shorts_denim_mask: 27360,
  ken_pose_ken_tee_brown: 98304,
  ken_pose_ken_tee_brown_mask: 16416,
  ken_pose_ken_tee_logo: 81920,
  ken_pose_ken_tee_logo_mask: 13680,
  ken_pose_mask: 49248,
  ken_pose_neck: 65536,
  ken_pose_neck_mask: 10944,
  ken_walk: 3538944,
  ken_walk_body: 3235840,
  ken_walk_body_mask: 539728,
  ken_walk_ears_ken_buzz: 143360,
  ken_walk_ears_ken_buzz_mask: 23968,
  ken_walk_ears_ken_fringe: 131072,
  ken_walk_ears_ken_fringe_mask: 21888,
  ken_walk_ears_ken_short_crop: 131072,
  ken_walk_ears_ken_short_crop_mask: 21888,
  ken_walk_ears_ken_spiky: 131072,
  ken_walk_ears_ken_spiky_mask: 21888,
  ken_walk_hair_ken_buzz: 839680,
  ken_walk_hair_ken_buzz_mask: 140384,
  ken_walk_hair_ken_curls: 1167360,
  ken_walk_hair_ken_curls_mask: 195168,
  ken_walk_hair_ken_fringe: 950272,
  ken_walk_hair_ken_fringe_mask: 158688,
  ken_walk_hair_ken_short_crop: 946176,
  ken_walk_hair_ken_short_crop_mask: 157872,
  ken_walk_hair_ken_spiky: 946176,
  ken_walk_hair_ken_spiky_mask: 157872,
  ken_walk_hairback_ken_buzz: 1,
  ken_walk_hairback_ken_buzz_mask: 1,
  ken_walk_hairback_ken_curls: 98304,
  ken_walk_hairback_ken_curls_mask: 16416,
  ken_walk_hairback_ken_fringe: 1,
  ken_walk_hairback_ken_fringe_mask: 1,
  ken_walk_hairback_ken_short_crop: 16384,
  ken_walk_hairback_ken_short_crop_mask: 2736,
  ken_walk_hairback_ken_spiky: 1,
  ken_walk_hairback_ken_spiky_mask: 1,
  ken_walk_ken_akc_beanie: 888832,
  ken_walk_ken_akc_beanie__bare: 888832,
  ken_walk_ken_akc_beanie__bare_mask: 148304,
  ken_walk_ken_akc_beanie_mask: 148304,
  ken_walk_ken_akc_cap: 757760,
  ken_walk_ken_akc_cap__bare: 757760,
  ken_walk_ken_akc_cap__bare_mask: 126688,
  ken_walk_ken_akc_cap_mask: 126688,
  ken_walk_ken_akc_headphones: 311296,
  ken_walk_ken_akc_headphones_mask: 51984,
  ken_walk_ken_akc_sunglasses: 262144,
  ken_walk_ken_akc_sunglasses_mask: 43776,
  ken_walk_ken_cargo: 946176,
  ken_walk_ken_cargo_mask: 157872,
  ken_walk_ken_hoodie: 1294336,
  ken_walk_ken_hoodie_mask: 216144,
  ken_walk_ken_jacket_plaid: 1196032,
  ken_walk_ken_jacket_plaid_mask: 199728,
  ken_walk_ken_jeans_black: 1196032,
  ken_walk_ken_jeans_black_mask: 199728,
  ken_walk_ken_joggers: 831488,
  ken_walk_ken_joggers_mask: 138736,
  ken_walk_ken_shoes_boots: 655360,
  ken_walk_ken_shoes_japonki: 622592,
  ken_walk_ken_shoes_japonki_mask: 103968,
  ken_walk_ken_shoes_runner: 638976,
  ken_walk_ken_shoes_white: 573440,
  ken_walk_ken_shorts_denim: 442368,
  ken_walk_ken_shorts_denim_mask: 73728,
  ken_walk_ken_tee_brown: 745472,
  ken_walk_ken_tee_brown_mask: 124384,
  ken_walk_ken_tee_logo: 716800,
  ken_walk_ken_tee_logo_mask: 119600,
  ken_walk_mask: 590976,
  ken_walk_neck: 401408,
  ken_walk_neck_mask: 66976,
  natalka_pose: 278528,
  natalka_pose_akc_kapelusz: 131072,
  natalka_pose_akc_kapelusz_mask: 21888,
  natalka_pose_akc_kokarda: 49152,
  natalka_pose_akc_korona: 81920,
  natalka_pose_akc_okulary: 49152,
  natalka_pose_bluzka_blue: 98304,
  natalka_pose_bluzka_green: 98304,
  natalka_pose_bluzka_green_mask: 16416,
  natalka_pose_bluzka_red: 81920,
  natalka_pose_bluzka_stripes: 98304,
  natalka_pose_bluzka_stripes_mask: 16416,
  natalka_pose_buty_balet: 81920,
  natalka_pose_buty_kozaki: 81920,
  natalka_pose_buty_sandaly: 65536,
  natalka_pose_buty_sandaly_mask: 10944,
  natalka_pose_buty_sport: 65536,
  natalka_pose_buty_sport_mask: 10944,
  natalka_pose_hair_nat_half_up: 163840,
  natalka_pose_hair_nat_half_up_hat: 163840,
  natalka_pose_hair_nat_half_up_hat_mask: 27360,
  natalka_pose_hair_nat_half_up_mask: 27360,
  natalka_pose_hair_nat_long_sleek: 163840,
  natalka_pose_hair_nat_long_sleek_mask: 27360,
  natalka_pose_hair_nat_pigtails: 114688,
  natalka_pose_hair_nat_pigtails_mask: 19152,
  natalka_pose_hair_nat_ponytail: 147456,
  natalka_pose_hair_nat_ponytail_hat: 147456,
  natalka_pose_hair_nat_ponytail_hat_mask: 24624,
  natalka_pose_hair_nat_ponytail_mask: 24624,
  natalka_pose_hair_nat_ringlets: 147456,
  natalka_pose_hair_nat_ringlets_hat: 147456,
  natalka_pose_hair_nat_ringlets_hat_mask: 24624,
  natalka_pose_hair_nat_ringlets_mask: 24624,
  natalka_pose_hair_nat_rounded_bob: 131072,
  natalka_pose_hair_nat_rounded_bob_mask: 21888,
  natalka_pose_hair_nat_wavy_lob: 131072,
  natalka_pose_hair_nat_wavy_lob_mask: 21888,
  natalka_pose_hairback_nat_half_up: 131072,
  natalka_pose_hairback_nat_half_up_hat: 114688,
  natalka_pose_hairback_nat_half_up_hat_mask: 19152,
  natalka_pose_hairback_nat_half_up_mask: 21888,
  natalka_pose_hairback_nat_long_sleek: 114688,
  natalka_pose_hairback_nat_long_sleek_mask: 19152,
  natalka_pose_hairback_nat_pigtails: 65536,
  natalka_pose_hairback_nat_pigtails_mask: 10944,
  natalka_pose_hairback_nat_ponytail: 114688,
  natalka_pose_hairback_nat_ponytail_hat: 131072,
  natalka_pose_hairback_nat_ponytail_hat_mask: 21888,
  natalka_pose_hairback_nat_ponytail_mask: 19152,
  natalka_pose_hairback_nat_ringlets: 131072,
  natalka_pose_hairback_nat_ringlets_hat: 131072,
  natalka_pose_hairback_nat_ringlets_hat_mask: 21888,
  natalka_pose_hairback_nat_ringlets_mask: 21888,
  natalka_pose_hairback_nat_rounded_bob: 98304,
  natalka_pose_hairback_nat_rounded_bob_mask: 16416,
  natalka_pose_hairback_nat_wavy_lob: 98304,
  natalka_pose_hairback_nat_wavy_lob_mask: 16416,
  natalka_pose_mask: 46512,
  natalka_pose_nat_basket_shoes: 81920,
  natalka_pose_nat_basket_shoes_mask: 13680,
  natalka_pose_nat_bucket_hat: 81920,
  natalka_pose_nat_bucket_hat_mask: 13680,
  natalka_pose_nat_corduroy: 114688,
  natalka_pose_nat_corduroy_mask: 19152,
  natalka_pose_nat_flares_lavender: 114688,
  natalka_pose_nat_flares_lavender_mask: 19152,
  natalka_pose_nat_fleece_brown: 131072,
  natalka_pose_nat_fleece_brown_mask: 21888,
  natalka_pose_nat_headband: 32768,
  natalka_pose_nat_headphones: 65536,
  natalka_pose_nat_jacket_denim: 114688,
  natalka_pose_nat_jeans_wide: 114688,
  natalka_pose_nat_jeans_wide_mask: 19152,
  natalka_pose_nat_jersey_basket: 98304,
  natalka_pose_nat_jersey_basket_mask: 16416,
  natalka_pose_nat_joggers_light: 98304,
  natalka_pose_nat_joggers_light_mask: 16416,
  natalka_pose_nat_parachute: 98304,
  natalka_pose_nat_parachute_mask: 16416,
  natalka_pose_nat_patchwork: 98304,
  natalka_pose_nat_patchwork_mask: 16416,
  natalka_pose_nat_slipons_check: 65536,
  natalka_pose_nat_slipons_check_mask: 10944,
  natalka_pose_nat_sweater_band: 114688,
  natalka_pose_nat_tee_blue_word: 98304,
  natalka_pose_nat_tee_blue_word_mask: 16416,
  natalka_pose_nat_tee_wave: 81920,
  natalka_pose_nat_tee_wave_mask: 13680,
  natalka_pose_nat_vest_puffer: 98304,
  natalka_pose_nat_vest_puffer_mask: 16416,
  natalka_pose_nat_wellies: 81920,
  natalka_pose_neck: 65536,
  natalka_pose_neck_mask: 10944,
  natalka_pose_spodniczka_black: 81920,
  natalka_pose_spodniczka_flowers: 81920,
  natalka_pose_spodniczka_jeans: 114688,
  natalka_pose_spodniczka_pink: 81920,
  natalka_pose_spodniczka_pink_mask: 13680,
  natalka_walk: 3473408,
  natalka_walk_akc_kapelusz: 1208320,
  natalka_walk_akc_kapelusz_mask: 202016,
  natalka_walk_akc_kokarda: 442368,
  natalka_walk_akc_kokarda_mask: 73872,
  natalka_walk_akc_korona: 540672,
  natalka_walk_akc_okulary: 430080,
  natalka_walk_akc_okulary_mask: 71760,
  natalka_walk_bluzka_blue: 819200,
  natalka_walk_bluzka_blue_mask: 136960,
  natalka_walk_bluzka_green: 917504,
  natalka_walk_bluzka_green_mask: 153088,
  natalka_walk_bluzka_red: 802816,
  natalka_walk_bluzka_red_mask: 134064,
  natalka_walk_bluzka_stripes: 778240,
  natalka_walk_bluzka_stripes_mask: 130112,
  natalka_walk_body: 3276800,
  natalka_walk_body_mask: 546560,
  natalka_walk_buty_balet: 540672,
  natalka_walk_buty_balet_mask: 90288,
  natalka_walk_buty_kozaki: 622592,
  natalka_walk_buty_sandaly: 737280,
  natalka_walk_buty_sandaly_mask: 123264,
  natalka_walk_buty_sport: 638976,
  natalka_walk_buty_sport_mask: 106496,
  natalka_walk_ears: 143360,
  natalka_walk_ears_mask: 23968,
  natalka_walk_ears_nat_half_up: 229376,
  natalka_walk_ears_nat_half_up_hat: 258048,
  natalka_walk_ears_nat_half_up_hat_mask: 43056,
  natalka_walk_ears_nat_half_up_mask: 38272,
  natalka_walk_ears_nat_long_sleek: 196608,
  natalka_walk_ears_nat_long_sleek_hat: 258048,
  natalka_walk_ears_nat_long_sleek_hat_mask: 43056,
  natalka_walk_ears_nat_long_sleek_mask: 32832,
  natalka_walk_ears_nat_ponytail: 270336,
  natalka_walk_ears_nat_ponytail_hat: 319488,
  natalka_walk_ears_nat_ponytail_hat_mask: 53248,
  natalka_walk_ears_nat_ponytail_mask: 45056,
  natalka_walk_ears_nat_ringlets: 196608,
  natalka_walk_ears_nat_ringlets_hat: 212992,
  natalka_walk_ears_nat_ringlets_hat_mask: 35568,
  natalka_walk_ears_nat_ringlets_mask: 32832,
  natalka_walk_ears_nat_rounded_bob: 344064,
  natalka_walk_ears_nat_rounded_bob_hat: 307200,
  natalka_walk_ears_nat_rounded_bob_hat_mask: 51360,
  natalka_walk_ears_nat_rounded_bob_mask: 57456,
  natalka_walk_ears_nat_wavy_lob: 163840,
  natalka_walk_ears_nat_wavy_lob_hat: 245760,
  natalka_walk_ears_nat_wavy_lob_hat_mask: 41088,
  natalka_walk_ears_nat_wavy_lob_mask: 27360,
  natalka_walk_hair_nat_half_up: 1347584,
  natalka_walk_hair_nat_half_up_hat: 1343488,
  natalka_walk_hair_nat_half_up_hat_mask: 224352,
  natalka_walk_hair_nat_half_up_mask: 224848,
  natalka_walk_hair_nat_long_sleek: 1548288,
  natalka_walk_hair_nat_long_sleek_hat: 1548288,
  natalka_walk_hair_nat_long_sleek_hat_mask: 258336,
  natalka_walk_hair_nat_long_sleek_mask: 258336,
  natalka_walk_hair_nat_pigtails: 1327104,
  natalka_walk_hair_nat_pigtails_mask: 221616,
  natalka_walk_hair_nat_ponytail: 1863680,
  natalka_walk_hair_nat_ponytail_hat: 1925120,
  natalka_walk_hair_nat_ponytail_hat_mask: 321104,
  natalka_walk_hair_nat_ponytail_mask: 311584,
  natalka_walk_hair_nat_ringlets: 1249280,
  natalka_walk_hair_nat_ringlets_hat: 1163264,
  natalka_walk_hair_nat_ringlets_hat_mask: 194256,
  natalka_walk_hair_nat_ringlets_mask: 208864,
  natalka_walk_hair_nat_rounded_bob: 1548288,
  natalka_walk_hair_nat_rounded_bob_hat: 1589248,
  natalka_walk_hair_nat_rounded_bob_hat_mask: 265392,
  natalka_walk_hair_nat_rounded_bob_mask: 258048,
  natalka_walk_hair_nat_wavy_lob: 1064960,
  natalka_walk_hair_nat_wavy_lob_hat: 1032192,
  natalka_walk_hair_nat_wavy_lob_hat_mask: 172368,
  natalka_walk_hair_nat_wavy_lob_mask: 177840,
  natalka_walk_hairback_nat_half_up: 491520,
  natalka_walk_hairback_nat_half_up_hat: 557056,
  natalka_walk_hairback_nat_half_up_hat_mask: 93024,
  natalka_walk_hairback_nat_half_up_mask: 82080,
  natalka_walk_hairback_nat_long_sleek: 659456,
  natalka_walk_hairback_nat_long_sleek_hat: 671744,
  natalka_walk_hairback_nat_long_sleek_hat_mask: 112176,
  natalka_walk_hairback_nat_long_sleek_mask: 110032,
  natalka_walk_hairback_nat_pigtails: 704512,
  natalka_walk_hairback_nat_pigtails_mask: 117648,
  natalka_walk_hairback_nat_ponytail: 245760,
  natalka_walk_hairback_nat_ponytail_hat: 589824,
  natalka_walk_hairback_nat_ponytail_hat_mask: 98304,
  natalka_walk_hairback_nat_ponytail_mask: 41088,
  natalka_walk_hairback_nat_ringlets: 368640,
  natalka_walk_hairback_nat_ringlets_hat: 294912,
  natalka_walk_hairback_nat_ringlets_hat_mask: 49248,
  natalka_walk_hairback_nat_ringlets_mask: 61488,
  natalka_walk_hairback_nat_rounded_bob: 245760,
  natalka_walk_hairback_nat_rounded_bob_hat: 225280,
  natalka_walk_hairback_nat_rounded_bob_hat_mask: 37664,
  natalka_walk_hairback_nat_rounded_bob_mask: 41040,
  natalka_walk_hairback_nat_wavy_lob: 212992,
  natalka_walk_hairback_nat_wavy_lob_hat: 184320,
  natalka_walk_hairback_nat_wavy_lob_hat_mask: 30816,
  natalka_walk_hairback_nat_wavy_lob_mask: 35568,
  natalka_walk_mask: 580032,
  natalka_walk_nat_basket_shoes: 696320,
  natalka_walk_nat_basket_shoes_mask: 116416,
  natalka_walk_nat_bucket_hat: 1081344,
  natalka_walk_nat_bucket_hat__bare: 1081344,
  natalka_walk_nat_bucket_hat__bare_mask: 180576,
  natalka_walk_nat_bucket_hat_mask: 180576,
  natalka_walk_nat_corduroy: 1114112,
  natalka_walk_nat_corduroy_mask: 186048,
  natalka_walk_nat_flares_lavender: 1208320,
  natalka_walk_nat_flares_lavender_mask: 202016,
  natalka_walk_nat_fleece_brown: 1081344,
  natalka_walk_nat_fleece_brown_mask: 180576,
  natalka_walk_nat_headband: 557056,
  natalka_walk_nat_headband__nat_ponytail: 802816,
  natalka_walk_nat_headband__nat_ponytail_mask: 134064,
  natalka_walk_nat_headband_mask: 93024,
  natalka_walk_nat_headphones: 262144,
  natalka_walk_nat_headphones_mask: 43776,
  natalka_walk_nat_jacket_denim: 1490944,
  natalka_walk_nat_jacket_denim_mask: 248768,
  natalka_walk_nat_jeans_wide: 1228800,
  natalka_walk_nat_jeans_wide_mask: 205440,
  natalka_walk_nat_jersey_basket: 663552,
  natalka_walk_nat_joggers_light: 1167360,
  natalka_walk_nat_joggers_light_mask: 195168,
  natalka_walk_nat_parachute: 1048576,
  natalka_walk_nat_parachute_mask: 175104,
  natalka_walk_nat_patchwork: 1187840,
  natalka_walk_nat_slipons_check: 622592,
  natalka_walk_nat_sweater_band: 921600,
  natalka_walk_nat_sweater_band_mask: 154080,
  natalka_walk_nat_sweater_knit: 1048576,
  natalka_walk_nat_sweater_knit_mask: 175104,
  natalka_walk_nat_tee_blue_word: 745472,
  natalka_walk_nat_tee_blue_word_mask: 124384,
  natalka_walk_nat_tee_wave: 688128,
  natalka_walk_nat_vest_puffer: 835584,
  natalka_walk_nat_wellies: 786432,
  natalka_walk_nat_wellies_mask: 131328,
  natalka_walk_neck: 376832,
  natalka_walk_neck_mask: 62928,
  natalka_walk_spodniczka_black: 983040,
  natalka_walk_spodniczka_black_mask: 164352,
  natalka_walk_spodniczka_flowers: 884736,
  natalka_walk_spodniczka_flowers_mask: 147744,
  natalka_walk_spodniczka_jeans: 1245184,
  natalka_walk_spodniczka_jeans_mask: 207936,
  natalka_walk_spodniczka_pink: 802816,
  natalka_walk_spodniczka_pink_mask: 134064,
};
